import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'

class LogoBrandsFilterForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      counter: 0,
    }
  }

  onChange = (event) => {
    const { handleChange, setValueToField } = this.props

    setValueToField('nmBrand', event.target.value)

    const filter = {
      nmBrand: event.target.value,
    }

    handleChange(filter, this.state.counter)
    this.setState({ counter: this.state.counter + 1 })
  }

  render() {
    const { fields } = this.props
    return (
      <Row className='align-right'>
        <Col lgOffset={8} xs={4}>
          <Field {...fields.nmBrand} glyph='glyph glyph-magnifier'>
            <Input
              id='nmBrand'
              {...fields.nmBrand.input}
              onChange={this.onChange}
            />
          </Field>
        </Col>
      </Row>
    )
  }
}

LogoBrandsFilterForm.propTypes = {
  translate: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
}

const fields = ['nmBrand']

export default Form({ fields })(LogoBrandsFilterForm)

export { LogoBrandsFilterForm }
